import { useState, useEffect } from "react";
import { WhatsappLogo, X } from "@phosphor-icons/react";
import { useSettings } from "@/context/SettingsContext";

const FALLBACK_NUMBER = "+919876543210";
const FALLBACK_MSG = "Hi Mine AI team, I have a question about ___";

const buildHref = (number, msg) =>
  `https://wa.me/${(number || "").replace(/[^0-9]/g, "")}?text=${encodeURIComponent(msg || "")}`;

export default function WhatsAppFloating() {
  const { settings } = useSettings();
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState("");

  useEffect(() => {
    setPath(window.location.pathname);
  }, []);

  // Hide on admin and on print
  if (path.startsWith("/admin")) return null;

  const number = settings?.whatsapp_number || FALLBACK_NUMBER;
  const message = settings?.whatsapp_default_message || FALLBACK_MSG;

  // If admin explicitly clears the WhatsApp number, hide the button entirely.
  if (!number || !number.replace(/[^0-9]/g, "")) return null;

  return (
    <>
      {open && (
        <div
          className="fixed bottom-24 right-4 sm:right-6 z-50 mc-card p-4 w-[280px] shadow-2xl print:hidden"
          data-testid="whatsapp-card"
        >
          <button
            onClick={() => setOpen(false)}
            className="absolute top-2 right-2 text-[#4A5568] hover:text-[#0A1128]"
            aria-label="close"
          >
            <X size={16} />
          </button>
          <div className="flex items-center gap-2">
            <WhatsappLogo size={24} weight="fill" className="text-[#25D366]" />
            <p className="font-display text-lg text-[#0A1128]">Chat on WhatsApp</p>
          </div>
          <p className="text-xs text-[#4A5568] mt-2 leading-relaxed">
            Mine AI support is on WhatsApp. Tap below and we'll reply within working hours.
          </p>
          <a
            href={buildHref(number, message)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-open-link"
            className="mt-3 block w-full text-center py-2.5 rounded-md bg-[#25D366] text-white font-medium hover:opacity-90 smooth"
          >
            Open WhatsApp
          </a>
          <p className="text-[10px] text-[#4A5568]/70 mt-2 text-center">
            Free messaging. Response within working hours.
          </p>
        </div>
      )}
      <button
        data-testid="whatsapp-floating-btn"
        aria-label="Open WhatsApp support"
        onClick={() => setOpen(!open)}
        className="fixed bottom-5 right-4 sm:right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 smooth flex items-center justify-center print:hidden"
      >
        {open ? <X size={22} weight="bold" /> : <WhatsappLogo size={28} weight="fill" />}
      </button>
    </>
  );
}
